var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"photo-license-icons"},[_c('i',{staticClass:"icon cc-logo is-size-4 has-text-black has-background-white",attrs:{"title":"CC"}}),_vm._l((_vm.getLicenseIcon(_vm.license)),function(l,i){
var _obj;
return [(l)?_c('i',{key:i,class:( _obj = {
          icon: true
        }, _obj['has-text-black'] = true, _obj['has-background-white'] = true, _obj['is-size-4'] = true, _obj[("cc-" + l)] = true, _obj ),attrs:{"alt":("" + (l.toUpperCase()))}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }